import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

export default {
    apiGetBlob: function(path) {
        var url = ConfigManager.getBlobUrl() + path;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    }
};
